import { DataCache } from './data-cache';
import { InsuranceProviders } from '../../enums/insurance-providers';

/**
 * @typedef {any} Provider
 * @typedef {any} Marketplace
 * @typedef {any} FillProvider
 * @typedef {any} InsuranceProvider
 */

/**
 * @param {object} props
 * @param {string|number} [props.providerId]
 * @param {string|number} [props.carrierId]
 * @param {string|number} [props.marketplaceId]
 * @param {string|number} [props.fillProviderId]
 * @param {string|number} [props.insuranceProviderId]
 * @returns {Provider|InsuranceProvider}
 */
export const getDisplayInformation = ({ providerId, carrierId, marketplaceId, fillProviderId, insuranceProviderId }) => {
  const cache = DataCache.getCache() || {};
  const providers = cache.providers || [];
  const marketplaces = cache.marketplaces || [];
  const fillProviders = cache.fillProviders || [];

  if (providerId) {
    return providers.find(
      (provider) => provider.providerId === providerId || Number.parseInt(provider.providerId, 10) === Number.parseInt(providerId, 10),
    );
  }
  if (carrierId) {
    return providers.find(
      (provider) => provider.carrierId === carrierId || Number.parseInt(provider.carrierId, 10) === Number.parseInt(carrierId, 10),
    );
  }
  if (fillProviderId) {
    return fillProviders.find(
      (fill) => fill.fillProviderId === fillProviderId || Number.parseInt(fill.fillProviderId, 10) === Number.parseInt(fillProviderId, 10),
    );
  }
  if (insuranceProviderId) {
    const _insuranceProviderId = `${insuranceProviderId}`;
    return Object.values(InsuranceProviders).find((insuranceProvider) => insuranceProvider?.insuranceProviderId === _insuranceProviderId);
  }

  return marketplaces.find(
    (marketplace) =>
      marketplace.marketplaceId === marketplaceId || Number.parseInt(marketplace.marketplaceId, 10) === Number.parseInt(marketplaceId, 10),
  );
};
